<template>
  <div class="breadcrumb-box">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        {{ breadcrumb.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "GlobalBreadcrumb"
}
</script>

<script setup>
import { computed } from "vue";
import {useUserStore} from "@/store/module/user";
import {useRoute} from "vue-router";
import {getParents} from "@/layouts/composable/useMenu";


const userStore = useUserStore();
const route = useRoute();
const breadcrumbs = computed(() => getParents(userStore.menuList, route.path)?.reverse());
</script>
<style scoped>
.breadcrumb-box{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: space-between;
}
:deep(.el-breadcrumb__inner){
  color:var(--el-text-color-secondary) !important;
}
:deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover){
  color:var(--el-text-color) !important;
  font-weight: bold;
}
.breadcrumb-box :deep(.el-icon){
  margin-right:2px;
}
</style>